import type { TipoDePublicacaoDto } from "@base/contracts";

/**
 * Infere o tipo do post a partir dos arquivos escolhidos.
 * 1 vídeo => reels; 2+ arquivos => carrossel; caso contrário => imagem.
 */
export function inferirTipoDeMidias(
  arquivos: readonly File[],
): TipoDePublicacaoDto {
  if (arquivos.length === 0) return "imagem";
  const soVideo =
    arquivos.length === 1 && arquivos[0]!.type.startsWith("video/");
  if (soVideo) return "reels";
  if (arquivos.length >= 2) return "carrossel";
  return "imagem";
}
